<div class="tabs-container">
    <div class="tabs">
      @for (tab of tabs(); track $index) {
        @if (tab?.isFullAccessOnly === undefined || tab?.isFullAccessOnly) {
          @if (tab?.requiredPermissions) {
            <div 
              *accessControl="{ permissions: tab.requiredPermissions, oneIsTrue: true }"
              class="tab"
              [class.active]="pageTabModeService.activeTabId() === tab.id"
              (click)="pageTabModeService.setActiveTab(tab.id)"
            >
              <div class="tab-content">
                <div class="tab-label label-large">{{ tab.displayLabel }}</div>
                <div class="active-indicator" *ngIf="pageTabModeService.activeTabId() === tab.id" [@indicatorAnimation]></div>
              </div>
            </div>
          } @else {
            <div 
              class="tab"
              [class.active]="pageTabModeService.activeTabId() === tab.id"
              (click)="pageTabModeService.setActiveTab(tab.id)"
            >
              <div class="tab-content">
                <div class="tab-label label-large">{{ tab.displayLabel }}</div>
                <div class="active-indicator" *ngIf="pageTabModeService.activeTabId() === tab.id" [@indicatorAnimation]></div>
              </div>
            </div>
          }
        }
      }
    </div>
</div>
